(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bs-announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.bs-announce').forEach(function(bar){
    var msgs = bar.querySelectorAll('.bs-announce__msg');
    if (msgs.length < 2) return;
    var i = 0;
    var interval = parseInt(bar.dataset.interval, 10) || 4000;
    setInterval(function(){
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }, interval);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bs-product-showcase"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.bsg-prod__atc[data-variant-id]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (btn.classList.contains('is-loading')) return;
      btn.classList.add('is-loading');
      var original = btn.textContent;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 })
      })
      .then(function(r){ if (!r.ok) throw new Error(); return r.json(); })
      .then(function(){
        btn.classList.add('is-added');
        btn.textContent = '✓ Added to cart';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function(){
          btn.classList.remove('is-added', 'is-loading');
          btn.textContent = original;
        }, 2200);
      })
      .catch(function(){
        btn.textContent = 'Try again';
        btn.classList.remove('is-loading');
        setTimeout(function(){ btn.textContent = original; }, 2000);
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bsg-editorial-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('.bsg-banner__timer').forEach(function(timer){
    var end = new Date(timer.dataset.end.replace(' ', 'T'));
    if (isNaN(end)) return;
    var els = {
      days: timer.querySelector('[data-unit="days"]'),
      hours: timer.querySelector('[data-unit="hours"]'),
      mins: timer.querySelector('[data-unit="mins"]'),
      secs: timer.querySelector('[data-unit="secs"]')
    };
    function pad(n){ return String(n).padStart(2, '0'); }
    function tick(){
      var diff = end - Date.now();
      if (diff <= 0){ timer.style.display = 'none'; clearInterval(iv); return; }
      var s = Math.floor(diff / 1000);
      els.days.textContent = pad(Math.floor(s / 86400));
      els.hours.textContent = pad(Math.floor(s % 86400 / 3600));
      els.mins.textContent = pad(Math.floor(s % 3600 / 60));
      els.secs.textContent = pad(s % 60);
    }
    tick();
    var iv = setInterval(tick, 1000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
